export const environment = {
    production: false,
    apiUrl: 'https://dev.zamadev.com/',
    envName: 'dev'
};